import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import AudioDashboard from '../../../BreathworkHub/AudioDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyBreathworkAudio } from './companyBreathworkApi';

/** Company Breathwork → Audio Dashboard, scoped to this company. */
const CBreathworkAudio = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyBreathworkAudio(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Breathwork Audio | Shoorah</title>
      </Helmet>
      {/*
        Content management is a Shoorah-admin surface, not a company one — and
        so is the catalogue itself: a company sees only what its own people
        played, so the library panels give way to reach into the population.
      */}
      <AudioDashboard
        fetcher={fetcher}
        showManageAction={false}
        showLibrary={false}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CBreathworkAudio;
